module.exports = __webpack_public_path__ + "img/the-field-gal-5.73b36881.jpg";